import React from 'react';
import { Helmet } from "react-helmet";

function RefundPolicy() {
  return (
    <>
      <Helmet>
        <title>Haridem - Photography Studio Premium | Servizi Fotografici Professionali</title>
        <meta name="description" content="Haridem Photography Studio - Servizi fotografici professionali premium, ritratti artistici, gallerie contemporanee e attrezzatura fotografica di alta qualita" />
      </Helmet>

      <div className="policy-container">
      <h1>Politica di Rimborso</h1>
      <p className="policy-date">Ultimo aggiornamento: 15 Gennaio 2025</p>

      <h2>Introduzione</h2>
      <p>
        La presente Politica di Rimborso regola le condizioni e le procedure per richiedere il 
        rimborso di servizi fotografici acquistati da Haridem Photography Studio, con sede in 
        Piazza Donato 73 Piano 4, Santoro laziale, 80571, Cuneo, Italia, Partita IVA 01916989. 
        Ci impegniamo a garantire la massima soddisfazione dei nostri clienti e a gestire le 
        richieste di rimborso in modo equo e trasparente.
      </p>

      <h2>Condizioni Generali di Rimborso</h2>
      <p>
        I servizi fotografici sono prestazioni personalizzate che richiedono pianificazione, 
        preparazione e allocazione di risorse specifiche. Per questo motivo, le condizioni di 
        rimborso variano in base alla tempistica della richiesta di cancellazione e allo stato 
        di avanzamento del servizio.
      </p>

      <h2>Rimborsi Prima della Sessione Fotografica</h2>
      <p>
        Per sessioni fotografiche non ancora eseguite, si applicano le seguenti condizioni di 
        rimborso in base al preavviso fornito:
      </p>
      <ul>
        <li>
          Cancellazione oltre 30 giorni prima della data prenotata: rimborso integrale del 100% 
          dell importo pagato, senza penalita
        </li>
        <li>
          Cancellazione tra 15 e 30 giorni prima: rimborso del 50% dell importo pagato, trattenuta 
          del 50% per costi organizzativi sostenuti
        </li>
        <li>
          Cancellazione tra 7 e 14 giorni prima: rimborso del 25% dell importo pagato
        </li>
        <li>
          Cancellazione entro 7 giorni dalla data prenotata: nessun rimborso, importo trattenuto 
          integralmente per compensare la mancata disponibilita dello slot
        </li>
      </ul>

      <h2>Rimborsi Dopo la Sessione Fotografica</h2>
      <p>
        Una volta completata la sessione fotografica, i rimborsi sono soggetti a valutazione caso 
        per caso e possono essere concessi solo in circostanze eccezionali, quali:
      </p>
      <ul>
        <li>
          Difetti tecnici gravi non risolvibili nelle fotografie dovuti a malfunzionamenti 
          dell attrezzatura dello Studio
        </li>
        <li>
          Mancata consegna delle fotografie entro i tempi concordati per cause imputabili allo Studio
        </li>
        <li>
          Sostanziale discrepanza tra il servizio promesso e quello effettivamente fornito
        </li>
      </ul>
      <p>
        In questi casi, lo Studio offrira prioritariamente una nuova sessione fotografica gratuita 
        o la correzione delle problematiche riscontrate. Il rimborso monetario sara considerato 
        solo se le soluzioni alternative non risultano accettabili per il Cliente.
      </p>

      <h2>Esclusioni dal Diritto di Rimborso</h2>
      <p>Non sono ammesse richieste di rimborso nei seguenti casi:</p>
      <ul>
        <li>
          Insoddisfazione soggettiva riguardo allo stile fotografico o alle scelte artistiche, 
          quando conformi agli esempi mostrati preventivamente
        </li>
        <li>
          Servizi gia completati e consegnati secondo le specifiche concordate
        </li>
        <li>
          Modifiche richieste dal Cliente dopo la consegna delle fotografie finite
        </li>
        <li>
          Assenza del Cliente alla sessione prenotata senza preavviso
        </li>
        <li>
          Condizioni atmosferiche avverse per sessioni outdoor, con possibilita di 
          riprogrammazione gratuita
        </li>
        <li>
          Ritardi nella consegna dovuti a cause di forza maggiore o eventi straordinari
        </li>
      </ul>

      <h2>Procedure per Richiedere un Rimborso</h2>
      <p>
        Per richiedere un rimborso, il Cliente deve seguire le seguenti procedure:
      </p>
      <ul>
        <li>
          Inviare richiesta scritta via email a <a href="mailto:haridem@hotmail.com">haridem@hotmail.com</a> entro 7 giorni dalla 
          data della sessione o dalla consegna delle fotografie
        </li>
        <li>
          Includere numero d ordine, data del servizio e motivazione dettagliata della richiesta
        </li>
        <li>
          Fornire eventuale documentazione a supporto della richiesta
        </li>
        <li>
          Attendere conferma di ricezione della richiesta entro 48 ore lavorative
        </li>
      </ul>

      <h2>Tempi di Elaborazione dei Rimborsi</h2>
      <p>
        Una volta approvata la richiesta di rimborso, lo Studio procedera con le seguenti tempistiche:
      </p>
      <ul>
        <li>Valutazione della richiesta entro 5 giorni lavorativi dalla ricezione</li>
        <li>Comunicazione dell esito al Cliente via email</li>
        <li>
          Elaborazione del rimborso entro 10 giorni lavorativi dall approvazione
        </li>
        <li>
          Accredito sul metodo di pagamento originale entro 5-10 giorni lavorativi aggiuntivi, 
          a seconda dell istituto bancario
        </li>
      </ul>

      <h2>Metodi di Rimborso</h2>
      <p>
        I rimborsi verranno effettuati esclusivamente tramite il metodo di pagamento utilizzato 
        per l acquisto originale. Non sono previsti rimborsi in contanti o su metodi di pagamento 
        diversi da quello utilizzato per l acquisto. In caso di pagamento con bonifico bancario, 
        sara necessario fornire coordinate bancarie valide per il rimborso.
      </p>

      <h2>Rimborsi Parziali</h2>
      <p>
        In determinate situazioni, lo Studio puo offrire rimborsi parziali, quali:
      </p>
      <ul>
        <li>
          Riduzione della durata della sessione per cause non imputabili al Cliente
        </li>
        <li>
          Consegna di un numero inferiore di fotografie rispetto a quanto concordato
        </li>
        <li>
          Servizi aggiuntivi non forniti come da contratto
        </li>
      </ul>
      <p>
        L importo del rimborso parziale sara calcolato proporzionalmente al servizio non 
        fornito o alla riduzione delle prestazioni.
      </p>

      <h2>Crediti e Alternative al Rimborso</h2>
      <p>
        Come alternativa al rimborso monetario, lo Studio puo offrire:
      </p>
      <ul>
        <li>
          Credito del 100% dell importo da utilizzare per servizi futuri entro 12 mesi
        </li>
        <li>
          Sessione fotografica aggiuntiva gratuita di valore equivalente
        </li>
        <li>
          Upgrade gratuito a un pacchetto di servizi superiore
        </li>
        <li>
          Stampe o album fotografici premium in omaggio
        </li>
      </ul>
      <p>
        Queste alternative possono risultare vantaggiose per il Cliente e sono sempre proposte 
        prima di procedere con il rimborso monetario.
      </p>

      <h2>Forza Maggiore</h2>
      <p>
        In caso di eventi di forza maggiore che impediscono l esecuzione del servizio fotografico, 
        quali emergenze sanitarie, calamita naturali, restrizioni governative o altri eventi 
        straordinari imprevedibili, lo Studio offrira:
      </p>
      <ul>
        <li>Riprogrammazione gratuita del servizio non appena possibile</li>
        <li>Credito completo da utilizzare entro 24 mesi</li>
        <li>Rimborso integrale se richiesto esplicitamente dal Cliente</li>
      </ul>

      <h2>Servizi con Sconti o Promozioni</h2>
      <p>
        Per servizi acquistati con sconti, promozioni o codici coupon, il rimborso sara calcolato 
        sull importo effettivamente pagato, non sul prezzo di listino originale. I codici sconto 
        o coupon utilizzati non verranno restituiti in caso di rimborso parziale o totale.
      </p>

      <h2>Pacchetti e Servizi Multipli</h2>
      <p>
        Per pacchetti che includono servizi multipli o sessioni fotografiche multiple, il rimborso 
        sara calcolato in base ai servizi gia fruiti. Se solo una parte del pacchetto e stata 
        utilizzata, il rimborso coprira esclusivamente la porzione non utilizzata, calcolata 
        proporzionalmente al valore totale del pacchetto.
      </p>

      <h2>Dispute e Risoluzione Controversie</h2>
      <p>
        In caso di disaccordo riguardo a una richiesta di rimborso, il Cliente puo richiedere 
        una revisione della decisione inviando una comunicazione scritta dettagliata entro 15 
        giorni dalla comunicazione dell esito. Lo Studio si impegna a riesaminare il caso con 
        attenzione e a fornire una risposta definitiva entro 10 giorni lavorativi.
      </p>

      <h2>Garanzia di Soddisfazione</h2>
      <p>
        Nonostante le condizioni di rimborso sopra indicate, Haridem Photography Studio si impegna 
        a garantire la massima soddisfazione dei propri clienti. Prima di procedere con qualsiasi 
        rimborso, faremo il possibile per risolvere eventuali problematiche attraverso:
      </p>
      <ul>
        <li>Dialogo diretto con il Cliente per comprendere le esigenze</li>
        <li>Proposte di soluzioni alternative personalizzate</li>
        <li>Modifiche o integrazioni al servizio fornito</li>
        <li>Post-produzione aggiuntiva o ritocchi fotografici extra</li>
      </ul>

      <h2>Modifiche alla Politica</h2>
      <p>
        Lo Studio si riserva il diritto di modificare la presente Politica di Rimborso in 
        qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con indicazione 
        della data di ultimo aggiornamento e si applicheranno agli acquisti effettuati dopo 
        la data di pubblicazione. Gli ordini gia confermati saranno soggetti alla politica 
        in vigore al momento dell acquisto.
      </p>

      <h2>Contatti per Assistenza</h2>
      <p>
        Per qualsiasi domanda, chiarimento o richiesta relativa ai rimborsi, il nostro team 
        di assistenza clienti e a tua completa disposizione:
      </p>
      <p>
        Haridem Photography Studio<br />
        Piazza Donato 73 Piano 4<br />
        Santoro laziale, 80571, Cuneo, Italia<br />
        Email: <a href="mailto:haridem@hotmail.com">haridem@hotmail.com</a><br />
        Email generale: <a href="mailto:haridem@hotmail.com">haridem@hotmail.com</a><br />
        Telefono: +39 4713811587<br />
        Partita IVA: 01916989
      </p>
      <p>
        Orari di assistenza: Lunedi - Venerdi 9:00 - 18:00, Sabato 10:00 - 14:00
      </p>
    </div>
  
    </>);
}

export default RefundPolicy;